import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES } from "@/libraries/web-framework";

const AtlassianGuardStandard = () => (
    <div>
        <h2>
            <FormattedMessage
                id="ConfluencePricingPageTeam24.features.atlassianGuardStandard.title"
                defaultMessage="Atlassian Guard Standard (SSO, SCIM, mobile app management)"
            />
        </h2>

        <p>
            <FormattedMessage
                id="ConfluencePricingPageTeam24.features.atlassianGuardStandard.body.summary"
                defaultMessage="Proactively protect your mission-critical work with advanced authentication controls and flexible security policies."
            />
        </p>
        <ul>
            <FormattedMessage
                id="ConfluencePricingPageTeam24.features.atlassianGuardStandard.body.listItems"
                defaultMessage="<li>Enforce Single Sign-on (SSO) and two-factor authentication</li> <li>Automate user lifecycle management (SCIM provisioning)</li> <li>Set policies for secure collaboration with external users</li> <li>Seamless integration with your Identity provider (IdP)</li>"
                values={{ ...DEFAULT_VALUES, li: (chunk) => <li>{chunk}</li> }}
            />
        </ul>
    </div>
);

export default AtlassianGuardStandard;
